import Vue from 'vue'
import Router from 'vue-router'
import EnrolTerminal from './views/EnrolTerminal.vue'
import Administrator from './views/Administrator.vue'
import Verify from './views/Verify.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/enrolTerminal/:terminalHash',
      name: 'EnrolTerminal',
      component: EnrolTerminal,
      props: true
    },
    {
      path: '/admin',
      name: 'admin',
      component: Administrator,
      props: true
    },
    {
      path: '/verify',
      name: 'verify',
      component: Verify,
      props: true
    },
  ]
});